// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-route-__index__page_pay"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/route/index.css
// module id = 1574
// module chunks = 0